import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Typography
} from "@mui/material";
import { authenticationService } from "src/services";
import { post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

interface AddZoneProps {
  handleClose: () => void;
  fetchZones: () => void;
}

const AddZone: React.FC<AddZoneProps> = ({
  handleClose,
  fetchZones
}) => {
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { showSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    isActive: true,
    vendorId: vendorId
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.name) {
      showSnackbar("Zone name is required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        id: 0,
        name: form.name,
        isActive: form.isActive,
        vendorId: form.vendorId
      };

      const response = await post(
        `${APIURL}/api/miscellaneous/zone`,
        payload
      );

      if (response?.statusCode === 200) {
        showSnackbar(response?.message || "Zone added successfully", "success");
        fetchZones();
        handleClose();
      } else {
        showSnackbar(response?.message || "Failed to add zone", "error");
      }
    } catch (error: any) {
      showSnackbar(error?.message || "Failed to add zone", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Add Zone
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Zone Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={e =>
                  setForm(prev => ({
                    ...prev,
                    isActive: e.target.checked
                  }))
                }
              />
            }
            label="Is Active"
          />
        </Grid>

        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddZone;
